import React from 'react'
import { Subtask } from 'constants/interfaces'
import { Button } from 'components/ui'
import { useExecutionLink } from '../../hooks/useExecutionLink'
import { AnswerDraft } from '../../model/execution'
import { useWorkspaceText } from '../../hooks/useWorkspaceText'
import styles from './styles.module.css'
export function ExecutionLinkAnswer({
  subtask,
  disabled,
}: {
  subtask: Subtask
  draft: AnswerDraft
  onChange: (draft: Partial<AnswerDraft>) => void
  disabled: boolean
}) {
  const open = useExecutionLink(subtask)
  const t = useWorkspaceText()
  return (
    <div className={styles.link}>
      <div>
        <strong>{subtask.title}</strong>
        <bdi>{subtask.external_link}</bdi>
        <Button variant="primary" onClick={open} isDisabled={disabled}>
          {t.openLink}
        </Button>
      </div>
      {!subtask.is_external_status_update && <p>{t.externalStatus}</p>}
    </div>
  )
}
